const humanReadableAddress = (stringAddress: string) => {
  const address = JSON.parse(stringAddress);

  return `${address?.line1}, ${address?.city}, ${address?.state}, ${address?.zip}, ${address?.country}`;
};

export default humanReadableAddress;
